var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGridbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_9-box",
    "data-name": "9-box",
    transform: "translate(-354 -167)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_269",
    "data-name": "Ellipse 269",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(354 167)",
    fill: "#004b75",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1414",
    "data-name": "Group 1414",
    transform: "translate(367.963 -771.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M7.263,959.364A.326.326,0,0,0,7,959.69v9.086a.326.326,0,0,0,0,.051v9.137a.326.326,0,0,0,0,.041v9.1a.326.326,0,0,0,.326.326h27.41a.326.326,0,0,0,.326-.326v-9.076a.326.326,0,0,0,0-.061v-9.137a.324.324,0,0,0,0-.041v-9.1a.326.326,0,0,0-.265-.326.33.33,0,0,0-.061,0H7.324a.32.32,0,0,0-.061,0Zm.387.653h8.484V968.5H7.651v-8.484Zm9.137,0h8.484V968.5H16.787Zm9.137,0h8.484V968.5H25.924ZM7.651,969.154h8.484v8.484H7.651Zm9.137,0h8.484v8.484H16.787Zm9.137,0h8.484v8.484H25.924ZM7.651,978.291h8.484v8.484H7.651Zm9.137,0h8.484v8.484H16.787Zm9.137,0h8.484v8.484H25.924Z",
    transform: "translate(0 0)",
    fill: "#004c75",
    stroke: "#004c75",
    strokeWidth: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridbox);
export default __webpack_public_path__ + "static/media/Gridbox.b267f2790ba72e0676bcb9312d247737.svg";
export { ForwardRef as ReactComponent };